import React, {useEffect, useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import Input from "../../../../common/Input";
import Dropdown from "../../../../primer/Dropdown";

const ChangeCategoryModal = ({show, setShow, defaultRowData, callbackFunction}) => {
    const [rowData, setRowData] = useState({});
    const categories = useSelector((state) => state.PRODUCTS_CATEGORY.categories);
    const subCategories = useSelector((state) => state.PRODUCTS_CATEGORY.subCategories);

    useEffect(() => {
        if (show && defaultRowData) {
            setRowData(defaultRowData);
        } else {
            setRowData({});
        }
    }, [show]);

    const onSave = () => {
        if (rowData.aiCategory) {
            callbackFunction(rowData.aiCategory);
            setShow(false);
        } else {
            toast.error("Παρακαλώ επιλέξτε κατηγορία.");
        }
    }

    const getCategories = () => {
        const categoryOptions = categories.map((o) => {
            return {
                value: o.title,
                label: o.title,
            }
        });
        const subCategoriesOptions = subCategories.map((o) => {
            const parent = categories.find((el) => el._id === o.parentCategory);
            if (parent) {
                return {
                    value: o.title,
                    label: `${parent.title} / ${o.title}`,
                }
            }
            return null;
        }).filter(Boolean);
        return [...categoryOptions, ...subCategoriesOptions];
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Τροποποίηση κατηγορίας / υποκατηγορίας</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {show && (
                      <React.Fragment>
                          <Input
                              name={"name"}
                              label={"Όνομα Είδους"}
                              disabled={true}
                              className={"mb-2"}
                              value={rowData.name}
                          />
                          <Dropdown
                              name={"category"}
                              label={"Κατηγορία / Υποκατηγορία είδους"}
                              className={"mb-2"}
                              options={getCategories()}
                              defaultValue={getCategories().find((el) => el.value === rowData.aiCategory)}
                              onChange={(e) => {
                                  setRowData({...rowData, aiCategory: e.value});
                              }}
                          />
                      </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => onSave()}>
                        Αποθήκευση
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default ChangeCategoryModal;
